module.exports = __webpack_public_path__ + "img/service-and-shop-filter-mitsu.47b59325.jpg";